import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCheckbox = ({
  fill = '#121212',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    data-testid="CheckBoxOutlineBlankIcon"
    fill={fill}
    {...props}
  >
    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
  </svg>
);
export default SvgCheckbox;
